// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    box-shadow: 2px 3px 4px 2px rgba(0, 0, 0, .1);
    background-color: var(--branco-padrao);
}

.header-top-container, .filtro-top-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: .7rem 1rem;
}

.filtro-top-container {
    padding: 0 1rem 1rem 1rem;
}

.textos-header-top-container {
    width: inherit;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: var(--azul-dixi);
}

.textos-header-top-container h3 {
    font-size: 1rem;
    font-weight: 700;
}

.botao-filtros-avancados-top-container {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: .3rem;
    font-size: .9rem;
    font-weight: 500;
}

.botao-filtros-avancados-top-container:hover {
    color: var(--botao-hover);
}

.divisor-top-container {
    margin-top: 0.4rem;
    color: var(--cinza-padrao);
    opacity: .2;
}

.filtro-top-container {
    display: flex;
    flex-direction: column;
}

.div-abaixo-top-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-top: 0.5rem;
}

.pesquisa-simples-top-container {
    display: flex;
    flex-direction: column;
    width: 50%;
}

.pesquisa-contem-label {
    color: var(--cinza-padrao2);
    display: flex;
    align-items: center;
    gap: .4rem;
    font-weight: 600;
    font-size: .9rem;
}

.icone-pesquisa-top-container {
    color: var(--azul-dixi);
}

input.pesquisa-contem {
    padding: .7rem .6rem;
    outline: none;
    border: none;
    background-color: var(--fundo-input);
    font-weight: 600;
    border-radius: 8px;
    color: var(--text-color);
}

input.pesquisa-contem:hover, input.pesquisa-contem:focus {
    outline: 2px solid var(--azul-dixi);
}

input.pesquisa-contem::placeholder {
    color: var(--cinza-padrao);
}

.botoes-top-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 1rem;
}

.botoes-top-container button {
    color: var(--branco-padrao);
    background: var(--azul-dixi);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: .5rem;
    font-weight: 500;
    padding: .7rem 0;
    width: 11rem;
    border-radius: 8px;
    border: none;
    transition: all .3s;
}

.botoes-top-container button:hover {
    cursor: pointer;
    background: var(--botao-hover);
}

.botoes-top-container button.novo-chamado {
    background: var(--branco-padrao);
    color: var(--azul-dixi);
    outline: 2px solid var(--azul-dixi);
    padding: .58rem 0;
    width: 11rem;
}

.botoes-top-container button.novo-chamado:hover {
    background: var(--azul-dixi);
    color: var(--branco-padrao);
}

.link {
    text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/components/TopContainer/TopContainer.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,6CAA6C;IAC7C,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,YAAY;IACZ,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;IAChC,uBAAuB;IACvB,mCAAmC;IACnC,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".top-container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    border-radius: 8px;\n    box-shadow: 2px 3px 4px 2px rgba(0, 0, 0, .1);\n    background-color: var(--branco-padrao);\n}\n\n.header-top-container, .filtro-top-container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    padding: .7rem 1rem;\n}\n\n.filtro-top-container {\n    padding: 0 1rem 1rem 1rem;\n}\n\n.textos-header-top-container {\n    width: inherit;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    color: var(--azul-dixi);\n}\n\n.textos-header-top-container h3 {\n    font-size: 1rem;\n    font-weight: 700;\n}\n\n.botao-filtros-avancados-top-container {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: .3rem;\n    font-size: .9rem;\n    font-weight: 500;\n}\n\n.botao-filtros-avancados-top-container:hover {\n    color: var(--botao-hover);\n}\n\n.divisor-top-container {\n    margin-top: 0.4rem;\n    color: var(--cinza-padrao);\n    opacity: .2;\n}\n\n.filtro-top-container {\n    display: flex;\n    flex-direction: column;\n}\n\n.div-abaixo-top-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 0.5rem;\n}\n\n.pesquisa-simples-top-container {\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n}\n\n.pesquisa-contem-label {\n    color: var(--cinza-padrao2);\n    display: flex;\n    align-items: center;\n    gap: .4rem;\n    font-weight: 600;\n    font-size: .9rem;\n}\n\n.icone-pesquisa-top-container {\n    color: var(--azul-dixi);\n}\n\ninput.pesquisa-contem {\n    padding: .7rem .6rem;\n    outline: none;\n    border: none;\n    background-color: var(--fundo-input);\n    font-weight: 600;\n    border-radius: 8px;\n    color: var(--text-color);\n}\n\ninput.pesquisa-contem:hover, input.pesquisa-contem:focus {\n    outline: 2px solid var(--azul-dixi);\n}\n\ninput.pesquisa-contem::placeholder {\n    color: var(--cinza-padrao);\n}\n\n.botoes-top-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 1rem;\n}\n\n.botoes-top-container button {\n    color: var(--branco-padrao);\n    background: var(--azul-dixi);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: .5rem;\n    font-weight: 500;\n    padding: .7rem 0;\n    width: 11rem;\n    border-radius: 8px;\n    border: none;\n    transition: all .3s;\n}\n\n.botoes-top-container button:hover {\n    cursor: pointer;\n    background: var(--botao-hover);\n}\n\n.botoes-top-container button.novo-chamado {\n    background: var(--branco-padrao);\n    color: var(--azul-dixi);\n    outline: 2px solid var(--azul-dixi);\n    padding: .58rem 0;\n    width: 11rem;\n}\n\n.botoes-top-container button.novo-chamado:hover {\n    background: var(--azul-dixi);\n    color: var(--branco-padrao);\n}\n\n.link {\n    text-decoration: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
